import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Sidebar = ({ onBackToSpeqqle }) => {
  const [expandedSections, setExpandedSections] = useState(new Set());

  const toggleSection = (section) => {
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(section)) {
        newSet.delete(section);
      } else {
        newSet.add(section);
      }
      return newSet;
    });
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-title">Speqqle Manual</div>
      <button className="back-button" onClick={onBackToSpeqqle}>
        Back to Speqqle
      </button>

      <ul>
        <li className="special-link">
          <NavLink to="/manual/welcome" className={({ isActive }) => isActive ? "active-link" : ""}>
            Welcome
          </NavLink>
        </li>

        {/* General Section */}
        <li className="expandable" onClick={() => toggleSection("general")}>
          General
        </li>
        <ul className={`sub-menu ${expandedSections.has("general") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/general/quickstart" className={({ isActive }) => isActive ? "active-link" : ""}>Quick Start</NavLink></li>
          <li><NavLink to="/manual/general/interface" className={({ isActive }) => isActive ? "active-link" : ""}>Interface</NavLink></li>
          <li><NavLink to="/manual/general/betaprogram" className={({ isActive }) => isActive ? "active-link" : ""}>BETA program</NavLink></li>
          <li><NavLink to="/manual/general/systemrequirements" className={({ isActive }) => isActive ? "active-link" : ""}>System Requirements</NavLink></li>
        </ul>

        {/* Data Loading Section */}
        <li className="expandable" onClick={() => toggleSection("data-loading")}>
          Data Loading
        </li>
        <ul className={`sub-menu ${expandedSections.has("data-loading") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/data-loading/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
        </ul>

        {/* Experiments Section */}
        <li className="expandable" onClick={() => toggleSection("experiments")}>
          Experiments
        </li>
        <ul className={`sub-menu ${expandedSections.has("experiments") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/experiments/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
          <li><NavLink to="/manual/experiments/modellist" className={({ isActive }) => isActive ? "active-link" : ""}>Full List of Experiments</NavLink></li>
          <li><NavLink to="/manual/experiments/newmodels" className={({ isActive }) => isActive ? "active-link" : ""}>Add new Experiments </NavLink></li>
          <li><NavLink to="/manual/experiments/loadmodels" className={({ isActive }) => isActive ? "active-link" : ""}>Load Experiments</NavLink></li>
          <li><NavLink to="/manual/experiments/materialmodels" className={({ isActive }) => isActive ? "active-link" : ""}>Material Models</NavLink></li>
          <li><NavLink to="/manual/experiments/managingmodels" className={({ isActive }) => isActive ? "active-link" : ""}>Managing Main and Submodels</NavLink></li>
        </ul>

        {/* Parameters Section */}
        <li className="expandable" onClick={() => toggleSection("parameters")}>
          Parameters
        </li>
        <ul className={`sub-menu ${expandedSections.has("parameters") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/parameters/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
          <li><NavLink to="/manual/parameters/editing" className={({ isActive }) => isActive ? "active-link" : ""}>Editing Parameters</NavLink></li>
          <li><NavLink to="/manual/parameters/constraints" className={({ isActive }) => isActive ? "active-link" : ""}>Constraints and Groups</NavLink></li>
          <li><NavLink to="/manual/parameters/fixing" className={({ isActive }) => isActive ? "active-link" : ""}>Fixing Parameters</NavLink></li>
          <li><NavLink to="/manual/parameters/multilayer" className={({ isActive }) => isActive ? "active-link" : ""}>Managing Multilayer Structures</NavLink></li>
          <li><NavLink to="/manual/parameters/saving" className={({ isActive }) => isActive ? "active-link" : ""}>Model Saving</NavLink></li>
          <li><NavLink to="/manual/parameters/paramcolors" className={({ isActive }) => isActive ? "active-link" : ""}>Parameter Color Code</NavLink></li>
        </ul>

        {/* Graphs Section */}
        <li className="expandable" onClick={() => toggleSection("graphs")}>
          Graphs
        </li>
        <ul className={`sub-menu ${expandedSections.has("graphs") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/graphs/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
          <li><NavLink to="/manual/graphs/addingdata" className={({ isActive }) => isActive ? "active-link" : ""}>Add Curves to Graph</NavLink></li>
          <li><NavLink to="/manual/graphs/customization" className={({ isActive }) => isActive ? "active-link" : ""}>Graph Settings</NavLink></li>
          <li><NavLink to="/manual/graphs/saving" className={({ isActive }) => isActive ? "active-link" : ""}>Saving Curves from Graph</NavLink></li>
          <li><NavLink to="/manual/graphs/interactive" className={({ isActive }) => isActive ? "active-link" : ""}>Updating Datasets via the Legend</NavLink></li>
          <li><NavLink to="/manual/graphs/exporting" className={({ isActive }) => isActive ? "active-link" : ""}>Exporting Graphs</NavLink></li>
        </ul>

        {/* Fitting Section */}
        <li className="expandable" onClick={() => toggleSection("fit")}>
          Fitting
        </li>
        <ul className={`sub-menu ${expandedSections.has("fit") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/fit/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
          <li><NavLink to="/manual/fit/least-sqr" className={({ isActive }) => isActive ? "active-link" : ""}>Least Square Fitting</NavLink></li>
          <li><NavLink to="/manual/fit/vdf-fit" className={({ isActive }) => isActive ? "active-link" : ""}>VDF Fit</NavLink></li>
          <li><NavLink to="/manual/fit/kk-trans" className={({ isActive }) => isActive ? "active-link" : ""}>KK transformations</NavLink></li>
        </ul>

        {/* Loop Operations Section */}
        <li className="expandable" onClick={() => toggleSection("loop")}>
          Batch Operations
        </li>
        <ul className={`sub-menu ${expandedSections.has("loop") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/loop/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
        </ul>

        {/* Special Packages Section */}
        <li className="expandable" onClick={() => toggleSection("packages")}>
          Special Packages
        </li>
        <ul className={`sub-menu ${expandedSections.has("packages") ? "expanded" : ""}`}>
          <li><NavLink to="/manual/packages/overview" className={({ isActive }) => isActive ? "active-link" : ""}>Overview</NavLink></li>
          <li><NavLink to="/manual/packages/speqqlebase" className={({ isActive }) => isActive ? "active-link" : ""}>Speqqle Base</NavLink></li>
        </ul>

        {/* Special Links */}
        <li className="special-link">
          <NavLink to="/manual/troubleshooting/overview" className={({ isActive }) => isActive ? "active-link" : ""}>
            Troubleshooting
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
